module.exports = __webpack_public_path__ + "img/logo-GivU-blanco.400356e6.svg";